var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "progress",
    style: {
      width: _vm.percent + "%",
      height: _vm.height,
      opacity: _vm.show ? 1 : 0,
      "background-color": _vm.canSuccess ? _vm.color : _vm.failedColor,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }